module.exports = __webpack_public_path__ + "fonts/DroidKufi-Bold.4650b9f9.woff2";